import { render, staticRenderFns } from "./account-password-change.vue?vue&type=template&id=4fe27771&"
import script from "./account-password-change.vue?vue&type=script&lang=js&"
export * from "./account-password-change.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports